const showButtonMore = () => {
    $('.js-scan').each(function (i, item) {
        const childItems = $(item).find('.checkboxField');
        if (childItems.length > 4) {
            $(item).find('.js-scan-buttons').addClass('show');
        } else {
            $(item).find('.js-scan-buttons').removeClass('show');
        }
    });
}

showButtonMore();

$(document).on('click', '.js-scan-btn', function() {
    const item = $(`.js-scan[data-id="${$(this).data('id')}"]`);
    const container = item.find('.scan__container');
    const group = item.find('.checkboxField');

    if (item.hasClass('scan--open')) {
        item.removeClass('scan--open');
    } else {
        $('.js-scan').removeClass('scan--open');
        item.addClass('scan--open');
    }

    if (item.hasClass('scan--open')) {
        if (group.length > 6 && group.length <= 8) {
            container.addClass('two');
        } else if (group.length > 9) {
            container.addClass('three');
        }
    } else {
        if (group.length > 6 && group.length <= 8) {
            container.removeClass('two');
        } else if (group.length > 9) {
            container.removeClass('three');
        }
    }
});
$(document).on('input', '.js-input-scan', function () {
    showButtonMore();
});

export const reinitFieldSideBarFilter = () => {
    showButtonMore();
}